import { render, staticRenderFns } from "./OTPVerifyModal.vue?vue&type=template&id=50f31f0f&scoped=true"
import script from "./OTPVerifyModal.vue?vue&type=script&lang=js"
export * from "./OTPVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./OTPVerifyModal.vue?vue&type=style&index=0&id=50f31f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f31f0f",
  null
  
)

export default component.exports